/* eslint-disable */

import { FORM_TEXTS } from '@jotforminc/constants';
import { getActiveApp, isEU, isHIPAA } from '@jotforminc/router-bridge';

import widgetAutoFill from '../utils/widgetAutofill';
import { loadWidgetImageInParentWindow, isBase64LoadedField } from '../utils/loadWidgetImageAsBase64';

document.addEventListener('DOMContentLoaded', () => {
  if (!JotForm.EventObserver) return;
  const form = document.querySelector('form.jotform-form');
  if (!(form instanceof HTMLFormElement)) return;
  function allWidgetsAreValid(e) {
    e.valid = document.querySelectorAll('.custom-field-frame[data-type="iframe"]').length === (JCFServerCommon.submitFrames || []).length;
    if (JotForm.debug) console.log('allWidgetsAreValid init: e.valid: ', e.valid);
    if (!JCFServerCommon.submitEvents) {
      JCFServerCommon.submitEvents = {};
    }
    JCFServerCommon.submitEvents[e.eventId] = e;
  }
  // define function name explicitly - name is perserved after minification
  Object.defineProperty(allWidgetsAreValid, 'name', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: 'allWidgetsAreValid'
  });
  form.addEventListener('submit', allWidgetsAreValid);
});

/**
 * @description widgetFrameLoaded->debounce is declared for each widget in a form, we need a debounce function which will
 * debounce across all widgets to perform only one submit event.
 * @param fn
 * @param delay
 * @returns {(function(): void)|*}
 */
function debounceFn(fn, delay) {
  var timer = null;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };
}

/**
 * @description A debounced submit function across all instances of `widgetFrameLoaded`. Ensures forms with
 * multiple widgets will only call submit once.
 * @param form An HTML Form element
 * @type {(function(): void)|*}
 */
var debouncedSubmit = debounceFn(function(form) {
  form.submit();
  // Some servers forms need extra time for the widgets to process. https://www.jotform.com/answers/14223291
}, ['maloneyproperties.jotform.com'].indexOf(window.location.host) > -1 ? 300 : 50);

/*
    function runs when widget iframe loaded
    look at onload attribute of related widget iframe
    it is passing iframe id
 */
function widgetFrameLoaded(id) {
  // iframe DOM object
  var frameObj = document.getElementById(`customFieldFrame_${id}`);
  var frameHeight = document.documentElement.clientHeight;
  var frameWidth = document.documentElement.clientWidth;
  var themeVersion = (window && window.newDefaultTheme) || '';
  // flag to show or hide console logs
  let enableLog = JotForm.debug

  /**
   * @type {{ id: string; widgetName: string; validationEvent: { valid: boolean | null  }|null }}
   */
  const _state = {
    id,
    widgetName: frameObj?.src.split('jotform.io/')?.[1]?.split('/')[0].toLowerCase() ?? '',
    validationEvent: null
  };
 
  const widgetActions = {
    get allWidgetsSubmitted() {
      const iframes = document.querySelectorAll('.custom-field-frame[data-type="iframe"]');
      return iframes.length === (JCFServerCommon.submitFrames || []).length;
    },
    /**
     * @return {( { valid: boolean | null, eventId: string } | null )}
     */
    get validationEvent() {
      return _state.validationEvent;
    },
    /**
     * @returns {( { valid: boolean | null, eventId: string } | null )}
     */
    get allWidgetsSubmittedEvent() {
      const event = widgetActions.validationEvent;
      if (event === null) return;
      if (!window.JCFServerCommon.submitEvents) return;
      const eventId = event.eventId;
      return window.JCFServerCommon.submitEvents[eventId];

    },
    set validationEvent(event) {
      _state.validationEvent = event;
    }
  };

  // form DOM object
  var thisForm = (JotForm.forms[0] == undefined || typeof JotForm.forms[0] === 'undefined') ? $($$('.jotform-form')[0].id) : JotForm.forms[0];

  // enable log for certain form
  if (~['241261768412051', '70261670492960', '62754049811963', '62261204289958', '62702584435962', '62802961818967', '72134468218962'].indexOf(thisForm.id)) {
    enableLog = true;
  }

  // if the iframe not full rendered don't do anything at it first
  if (!frameObj.hasClassName('custom-field-frame-rendered')) {
    enableLog && console.log('Not rendered yet for', id);
    return;
  }

  // if oEmbed, ignore
  if (isOembedWidget(id)) {
    return;
  }

  // register widget to JCFServerCommon object
  // useful while debugging forms with widgets
  JCFServerCommon.frames[id] = {};
  JCFServerCommon.frames[id].obj = frameObj;
  var { src } = frameObj;

  JCFServerCommon.frames[id].src = src;
  JCFServerCommon.submitFrames = [];

  // to determine whether submit message passed form submit or next page
  var nextPage = true;
  // to determine which section is open actually
  var section = false;

  // we are changing iframe src dynamically
  // at first load iframe does not have src attribute that is why it behaves like it has form's URL
  // to prevent dublicate events if it is form url return
  // if(src.match('/form/')) {
  //     console.log("returning from here");
  //     return;
  // }

  var referer = src;

  // detect IE version
  function getIEVersion() {
    var match = navigator.userAgent.match(/(?:MSIE |Trident\/.*; rv:)(\d+)/);
    return match ? parseInt(match[1]) : undefined;
  }

  // check if the form is valid and no errors
  function isTheFormValidated() {
    return $$('.form-line-error').length === 0;
  }

  // check a valid json string
  function IsValidJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  // check if object is empty
  function isEmpty(obj) {
    if (obj == null) return true;
    if (obj.constructor === Array
      || obj.constructor === String) return obj.length === 0;
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }

    return true;
  }

  // trim a string
  function trim(str) {
    if (getIEVersion() === 8) {
      return str.replace(/^\s+|\s+$/g, '');
    }

    return str.trim();
  }

  // check if oEmbed widget
  function isOembedWidget(id) {
    var isOembed = false;
    var iframeElement = document.getElementById(`customFieldFrame_${id}`);
    if (iframeElement.hasAttribute('data-type')) {
      var type = iframeElement.readAttribute('data-type');
      if (type === 'oembed') {
        isOembed = true;
      }
    }

    return isOembed;
  }

  // send message to widget iframe
  function sendMessage(msg, id, to) {
    var ref = referer;
    if (to !== undefined) { // to option is necesaary for messaging between widgets and themes page
      ref = to;
    }

    var iframeElement = document.getElementById(`customFieldFrame_${id}`);

    // if no iframe do not send postmessage
    if (iframeElement === null) {
      return;
    }

    if (navigator.userAgent.indexOf('Firefox') != -1) {
      XD.postMessage(msg, ref, getIframeWindow(iframeElement));
    } else if (getIEVersion() !== undefined) { // if IE
      XD.postMessage(msg, ref, iframeElement);
    } else {
      XD.postMessage(msg, ref, getIframeWindow(iframeElement));
    }
  }

  window.sendMessage2Widget = sendMessage;

  function resize() {
    var frameSizes = {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight
    };
    sendMessage(JSON.stringify({
      type: 'frame:resize',
      frameSizes: frameSizes
    }), id);
  }

  window.onresize = resize;

  // function that gets the widget settings from data-settings attribute of the iframe
  function getWidgetSettings() {
    var el = document.getElementById(`widget_settings_${id}`);
    return (el) ? el.value : null;
  }

  // debounce for key events
  function debounce(fn, delay) {
    var timer = null;
    return function () {
      var context = this; var
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(context, args);
      }, delay);
    };
  }

  // function to check if a widget is static
  function isWidgetStatic(id) {
    var el = document.getElementById(`input_${id}`);
    return (el && el.hasClassName('widget-static')) ? true : false;
  }

  // function to check if a widget is required
  function isWidgetRequired(id) {
    var classNames = document.getElementById(`id_${id}`).className;
    return classNames.indexOf('jf-required') > -1;
  }

  function isWidgetLabelEnabled(id) {
    var labelElement = document.getElementById(`label_${id}`);
    if (labelElement) {
      return labelElement.className.indexOf('form-label') > -1;
    }
    return false;
  }

  function getWidgetLabel(id) {
    var labelElement = document.getElementById(`label_${id}`);
    if (labelElement && labelElement.textContent) {
      return labelElement.textContent;
    }
    return '';
  }

  // check if the whole iframe is rendered
  // before processing the data from post message
  function isWidgetFrameReady(id) {
    var targetWidgetFrame = document.getElementById(`customFieldFrame_${id}`);
    return (!targetWidgetFrame.hasClassName('frame-ready')
      && !targetWidgetFrame.retrieve('frame-ready')) ? false : true;
  }

  // better way to check if edit mode
  function isEditMode() {
    return (JotForm.isEditMode()
      || !!~window.location.href.indexOf('/edit/')
      || !!~window.location.href.indexOf('inlineEdit'));
  }

  // insert new theme css directly if request comes from offline forms
  const isExtendedTheme = (window && window.JotForm.extendsNewTheme) || '';
  const params = global.location.search.split('?').join('');
  const isOfflineForms = params.indexOf('offline_forms=true') > -1 || params.indexOf('offline_forms=si') > -1;
  if(isOfflineForms && themeVersion === 'v2') {
    sendMessage(JSON.stringify({type: 'theme', themeVersion, isExtendedTheme}), id);
  }

  // send message to widget iframe and change data-status to ready
  function sendReadyMessage(id, eventType) {
    var formAll = document.querySelector('.form-all');
    var background = (window.getComputedStyle)
      ? window.getComputedStyle(formAll, null).getPropertyValue('background-color')
      : getStyle(formAll, 'background');
    var fontFamily = (window.getComputedStyle)
      ? window.getComputedStyle(formAll, null).getPropertyValue('font-family')
      : getStyle(formAll, 'font-family');

    // send ready message to widget
    // including background-color, formId, questionID and value if it is edit mode (through submissions page)

    // Check if card form or card builder
    var isCardForm = (window.FORM_MODE == 'cardform' || window.buildermode === 'card');

    //get form environment
    var appPath = !! getActiveApp() ? getActiveApp(): false ;
    var isEu = !! isEU() || JotForm.forwardToEu ? true: false;
    var isHipaa = !! isHIPAA() || JotForm.hipaa ? true: false;

    if (window.JotForm.uploadServerURL !== undefined) {
      var uploadServerURL = window.JotForm.uploadServerURL;
    }


    // Check theme version
    var themeVersion = (window && window.newDefaultTheme) || '';
    if (!themeVersion && window.JotForm.newDefaultTheme) {
      themeVersion = 'v2';
    }
    var isExtendedTheme = (window && window.JotForm.extendsNewTheme) || '';
    var msg = {
      type: 'ready',
      qid: `${id}`,
      isEditMode: window.JotForm.isEditMode(),
      sid: window.JotForm.submissionID,
      formID: document.getElementsByName('formID')[0].value,
      required: isWidgetRequired(id),
      static: isWidgetStatic(id),
      isWidgetLabelEnabled: isWidgetLabelEnabled(id),
      qlabel: getWidgetLabel(id),
      jotformNext: window.location.href.indexOf('jotformNext=1') > -1 || window.isComingFromJotFormNext == 1,
      cardform: isCardForm,
      background: background,
      fontFamily: fontFamily,
      origin: window.location.origin || (`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`),
      enterprise: JotForm.enterprise,
      themeVersion: themeVersion,
      isExtendedTheme: isExtendedTheme,
      isEu,
      isHipaa,
      isApp : appPath,
      lang: document.documentElement.lang,
      uploadServerURL: uploadServerURL
    };

    if (eventType) {
      msg.type = eventType;
    }

    // if settings not null, include it
    var _settings = getWidgetSettings();
    if (_settings && decodeURIComponent(_settings) !== '[]') {
      msg.settings = _settings;
    }

    // data-value attribute is set if form is in editMode.
    var wframe = document.getElementById(`customFieldFrame_${id}`);
    if (isCardForm && wframe && typeof wframe.up === 'function') {
      var jfFieldDiv = wframe.up('.jfField') || false;
      var widgetID = jfFieldDiv && typeof jfFieldDiv.getAttribute === 'function' ? jfFieldDiv.getAttribute('data-widget-id') : false;
      if (widgetID) {
        msg.widgetID = widgetID;
      }
    }

    // include initial width and height of the widget from the properties
    var fwidth = wframe.readAttribute('data-width') || wframe.parentNode.clientWidth;
    var fheight = wframe.readAttribute('data-height') || wframe.parentNode.clientHeight;
    msg.width = parseInt(fwidth);
    msg.height = parseInt(fheight);

    // get the view size of the iframe
    // this is the actual size when the form is loaded
    msg.viewWidth = wframe.parentNode.clientWidth;
    msg.viewHeight = wframe.parentNode.clientHeight;

    // helper function
    function _sendReadyMessage(id, msg) {
      // put a custom class when ready
      $(document.getElementById(`customFieldFrame_${id}`)).addClassName('frame-ready').store('frame-ready', true);

      // send ready message
      sendMessage(JSON.stringify(msg), id);
    }

    // make sure we get the data first before sending ready message, only when msg.value undefined
    var isEditMode = (JotForm.isEditMode()
      || !!~window.location.href.indexOf('/edit/')
      || !!~window.location.href.indexOf('inlineEdit'));

    enableLog && console.log('ready message inline', msg);

    if (isEditMode) {
      // if edit mode do some polling with timeout
      // interval number for each check in ms
      var interval = 50;
      // lets give the check interval a timeout in ms
      var timeout = 5000;
      // will determine the timeout value
      var currentTime = 0;

      var editCheckInterval = setInterval(() => {
        // clear interval when data-value attribute is set on the iframe
        // that means the 'getSubmissionResults' request has now the question data
        if (wframe.hasAttribute('data-value') || (currentTime >= timeout)) {
          // clear interval
          clearInterval(editCheckInterval);

          // renew value, whether its empty
          msg.value = wframe.getAttribute('data-value');

          // send message
          enableLog && console.log('Ready message sent in', currentTime, msg);
          if (isBase64LoadedField(msg, wframe.getAttribute('data-client-id'))) {
            loadWidgetImageInParentWindow(`/${msg.value}?${(new Date()).getTime()}`)
              .then((base64Image) => _sendReadyMessage(id, { ...msg, value: base64Image }))
              .catch(() => _sendReadyMessage(id, msg))
          } else {
            _sendReadyMessage(id, msg);
          }
        }

        currentTime += interval;
      }, interval);
    } else {
      // set value
      if (wframe.hasAttribute('data-value')) {
        msg.value = wframe.getAttribute('data-value');
      } else {
        // check if the hidden input has a value
        // TODO: improve this to make only work from back history
        var input = wframe.parentNode.select(`#input_${id}`);

        // if not empty, pass it to ready event value
        if (input.first().getValue()) {
          msg.state = 'oldvalue';
          msg.value = input.first().getValue();
        }
      }

      // send message
      enableLog && console.log('Sending normal ready message', msg);
      _sendReadyMessage(id, msg);
    }
  }

  // A hacky way to decode/unescape html entities on a string
  function unescapeEntities(str) {
    var txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }

  // A hacky way to encode/escape html entities on a string
  function escapeEntities(str) {
    var txt = document.createElement('textarea');
    txt.textContent = str;
    return txt.innerHTML;
  }

  // expose ready message function
  window.JCFServerCommon.frames[id].sendReadyMessage = sendReadyMessage;

  // bind receive message event
  // a message comes from form
  XD.receiveMessage(message => {
    // don't parse some unknown text from third party api of widgets like google recapthca
    if (!IsValidJsonString(message.data)) {
      return;
    }

    // parse message
    var data = JSON.parse(message.data);

    enableLog && console.log('Data from widget', data.qid, data);

    // filter out events from other frames which cause form hang up
    // specially if there are multiple widgets on 1 form
    if (parseInt(id) !== parseInt(data.qid)) {
      return;
    }

    // sendSubmit
    if (data.type === 'submit') {
      const validationEvent = widgetActions.validationEvent;
      enableLog && console.log('widget submit', document.getElementById(`input_${data.qid}`));
      // make sure thats its not an oEmbed widget
      // oEmbed widgets has no hidden input to read
      if (document.getElementById(`input_${data.qid}`)) {
        if (enableLog && !data.value) {
          console.log('received Data ', data);
          data.value = document.getElementById(`input_${data.qid}`).value;
        }

        if (typeof data.value === 'number') {
          data.value = `${data.value}`;
        }
        var required = $(document.getElementById(`input_${data.qid}`)).hasClassName('widget-required') || $(document.getElementById(`input_${data.qid}`)).hasClassName('validate[required]');
        var input_id_elem = document.getElementById(`input_${data.qid}`);
        var inputLineParent = input_id_elem.up('.form-line');

        var hasExludedEncryptWidgets = function (formData) {
            const formDataMatch = Boolean(typeof formData === 'string' && formData.match(/^data:image\/png;base64/ig));
            const metaData = !!~formData.indexOf('widget_metadata');
            const validString = IsValidJsonString(formData);
            return formDataMatch || metaData || validString;
        };

        // if the element/question was set to required, we do some necessary validation to display and error or not
        var isParentVisible = JotForm.isVisible(inputLineParent);
        var isElemVisible = (inputLineParent.hasClassName('form-field-hidden')
                             || input_id_elem.hasClassName('always-hidden') || !isParentVisible) ? false : true;
        if (required) {
          enableLog && console.log(data.qid, 'isVisible', isElemVisible);
          if (isElemVisible && 'valid' in data
            && ((data.valid === false) || (data.valid === true && !data.value))
          ) {

            if (validationEvent) validationEvent.valid = false;
            // only set empty value if the widget is ready
            // for non ready widgets, if theres an existing value
            // avoid getting it overwrite, like for example under collapse
            if (isWidgetFrameReady(data.qid)) {
              input_id_elem.setValue('');
              enableLog && console.log('LogA: Setting empty input value for', data.qid, data);
            } else {
              enableLog && console.log("LogA: Setting nothing because isn't ready", data.qid, data);
            }

            // put a custom error msg if necessary, only if error object is present
            // only error if its empty
            if (!input_id_elem.getValue()) {
              var jotformReqError = JotForm.texts && JotForm.texts.required ? JotForm.texts.required : FORM_TEXTS.required;
              var req_errormsg = jotformReqError || 'This field is required';
              if (typeof data.error !== 'undefined' && data.error !== false) {
                req_errormsg = (data.error.hasOwnProperty('msg')) ? data.error.msg : req_errormsg;
              }

              enableLog && console.log('Errored required element', input_id_elem, data);
              JotForm.errored(input_id_elem, req_errormsg);
            }
          } else {
            // do not correct errored widget under closed form collapse
            // as well as hidden widget fields
            if (isElemVisible && !JotForm.isCollapsed(input_id_elem)) {
              enableLog && console.log('Correcting required element', input_id_elem, data);
              JotForm.corrected(input_id_elem);
            }

            // for not visible widgets(for example already at the previouspage)
            // correct them if their data is valid
            if (!isElemVisible && data.valid === true) {
              enableLog && console.log('Correcting not visible element but valid', input_id_elem, data);
              JotForm.corrected(input_id_elem);
            }

            // only modify value if the widget frame is ready
            if (isWidgetFrameReady(data.qid)) {
              if (data.value !== undefined) {
                // if form encrypted, encrypt value
                var finalvalue = data.value;
                if (JotForm.isEncrypted && data.value && !hasExludedEncryptWidgets(data.value) && JotForm.encryptionProtocol !== "JF-CSE-V2") {
                  finalvalue = JotEncrypted.encrypt(data.value);
                }
                input_id_elem.setValue(escapeEntities(finalvalue));
                enableLog && console.log('LogB: Setting input value for', data.qid, data);
              } else {
                input_id_elem.setValue('');
                enableLog && console.log('LogC: Setting input value for', data.qid, data);
              }
            } else {
              enableLog && console.log('LogA: Widget frame not ready, no value set', data.qid, data);
            }
          }
        } else {
          // if not required and value property has a value set
          // make it as the hidden input value
          if (typeof data !== 'undefined') {
            if ('value' in data) {
              // only modify value if the widget frame is ready
              if (isWidgetFrameReady(data.qid)) {
                var finalvalue = data.value;
                if (JotForm.isEncrypted && data.value && !hasExludedEncryptWidgets(data.value) && JotForm.encryptionProtocol !== "JF-CSE-V2") {
                  finalvalue = JotEncrypted.encrypt(data.value);
                }
                input_id_elem.setValue(escapeEntities(finalvalue));
              } else {
                enableLog && console.log('LogB: Widget frame not ready, no value set', data.qid, data);
              }
            } else if (input_id_elem.hasClassName('widget-static')) {
              input_id_elem.setValue('');
              input_id_elem.removeAttribute('name');
            }
          }
        }

        // remove value if field is totally hidden or conditionally hidden
        // only when the Clear Hidden Field Values option is set
        if (input_id_elem && inputLineParent
          && inputLineParent.hasClassName('form-field-hidden')
          && JotForm.clearFieldOnHide === 'disable') {
          input_id_elem.setValue('');
          // input_id_elem.removeAttribute('name');
        }

        // flag the iframe widget already submitted
        if (JCFServerCommon.submitFrames.indexOf(parseInt(data.qid)) < 0) {
          // for required widgets and value not valid
          // removed them from submitted frames
          if (isElemVisible && required && !data.valid) {
            if (validationEvent) validationEvent.valid = false;
            // quiet
            enableLog && console.log('Waiting for frame submission, required but not valid', data.qid);
          } else {
            JCFServerCommon.submitFrames.push(parseInt(data.qid));
          }
        }
      }

      // check for widget required/errors and prevent submission
      var allInputs = $$('.widget-required, .widget-errored');
      var sendSubmit = true;
      for (var i = 0; i < allInputs.length; i++) {
        if (allInputs[i].value.length === 0 && JotForm.isVisible(allInputs[i])) {
          sendSubmit = false;
        }
      }
      // if widget is made required by condition
      // var requiredByConditionInputs = document.getElementsByClassName("form-widget validate[required]");
      // console.log("requiredByConditionInputs". requiredByConditionInputs.length);

      // for(var i=0; i<requiredByConditionInputs.length; i++) {
      //     if(requiredByConditionInputs[i].value.length === 0 && JotForm.isVisible(requiredByConditionInputs[i])) {
      //         sendSubmit = false;
      //     }
      // }

      if (!nextPage) {
        enableLog && console.log('next page', nextPage, isTheFormValidated(), sendSubmit);
        if (isTheFormValidated() && sendSubmit) {
          if (validationEvent) validationEvent.valid = true;
          enableLog && console.log('sendSubmit', nextPage, sendSubmit);
          var tf = (JotForm.forms[0] == undefined || typeof JotForm.forms[0] === 'undefined') ? $($$('.jotform-form')[0].id) : JotForm.forms[0];
          // Don't submit if form has Stripe, Braintree, Square. The form submits automatically after credit card is tokenized
          var isEditMode = (!!~window.location.href.indexOf('/edit/')) || window.location.search.match('inlineEdit|edit');
          var autoSubmit = ['stripe', 'braintree', 'square', 'wepay', 'eway', 'bluepay', 'moneris', 'paypalcomplete', 'mollie', 'stripeACHManual', 'pagseguro'];
          if (window.paymentType === 'subscription' && JotForm.payment === 'paypalcomplete') {
            autoSubmit.splice(autoSubmit.indexOf('paypalcomplete'), 1);
          }
        // EventObserver: Verify all widgets submitted
        // if so, set allWidgetSubmitEvent to true
        (() => {
          if (!JotForm.EventObserver) return;
          if (!widgetActions.allWidgetsSubmitted) return;
          const allWidgetsEvent = widgetActions.allWidgetsSubmittedEvent;
          if (!allWidgetsEvent) return;
          if (enableLog) {
            console.log(`client.js: widget_${_state.id} (${_state.widgetName}) will set allWidgetsEvent to:`, true);
          }
          allWidgetsEvent.valid = true;
        })();
          if (!((JotForm.payment
            && autoSubmit.indexOf(JotForm.payment) > -1
            && JotForm.isPaymentSelected()
            && (JotForm.paymentTotal > 0)
            && !isEditMode) || JotForm.isEncrypted || JotForm.disableSubmitButton || window.offlineForm)) {
            // we will submit the form if all widgets already submitted
            // because some widgets need to do their own processes before sending submit
            // check if all frames submitted a message, thats the time we fire a form submit
            if ($$('.custom-field-frame[data-type="iframe"]').length === JCFServerCommon.submitFrames.length) {
              enableLog && console.log('All frames submitted', JCFServerCommon.submitFrames);

              // TODO: Find an alternate method of deciding when a widget is finished processing.
              if (!JotForm.EventObserver) debouncedSubmit(tf);
            } else {
              enableLog && console.log('Not all frames submitted', JCFServerCommon.submitFrames);
            }
          }
        } else {
          if (validationEvent) validationEvent.valid = false;
          // if not valid and unableto submit
          // reset the form submission button
          JotForm.enableButtons();
          JotForm.showButtonMessage();

          // reset submitted frames, to avoid race submissions
          JCFServerCommon.submitFrames = [];
        }
      } else {
        if (validationEvent) validationEvent.valid = false;
        // var proceedSection = true;
        // section.select(".widget-required").each(function(inp) {
        //     if (inp.value.length === 0) {
        //         proceedSection = false;
        //     }
        // });

        // //@diki
        // //validate current section
        // var sectionValidated = true;
        // section.select('*[class*="validate"]').each(function(inp) {
        //     if (inp.validateInput === undefined) {
        //         return; /* continue; */
        //     }
        //     if (!( !! inp.validateInput && inp.validateInput())) {
        //         sectionValidated = JotForm.hasHiddenValidationConflicts(inp);
        //     }
        // });

        // if (proceedSection && sectionValidated) {
        //     if (window.parent && window.parent != window) {
        //         window.parent.postMessage('scrollIntoView', '*');
        //     }
        //     if (JotForm.nextPage) {
        //         JotForm.backStack.push(section.hide()); // Hide current
        //         JotForm.currentSection = JotForm.nextPage.show();
        //         //Emre: to prevent page to jump to the top (55389)
        //         if (typeof $this !== "undefined" && !$this.noJump) {
        //             JotForm.currentSection.scrollIntoView(true);
        //         }
        //         JotForm.enableDisableButtonsInMultiForms();
        //     } else if (section.next()) { // If there is a next page
        //         if(section.select(".widget-required").length > 0) {
        //             JotForm.backStack.push(section.hide()); // Hide current
        //             // This code will be replaced with condition selector
        //             JotForm.currentSection = section.next().show();
        //             JotForm.enableDisableButtonsInMultiForms();
        //         }
        //     }
        //     JotForm.nextPage = false;
        // }
      }
    }

    //sendCalcValue
    else if (data.type === 'calcvalue') {
      const inputEl = document.getElementById(`input_${data.qid}`);
      if (inputEl) {
        inputEl.setAttribute('data-calc', data.value);
      }
    }

    // sendData
    else if (data.type === 'data') {
      try {
        var el = document.getElementById(`input_${data.qid}`);
        if (el) {
          el.value = data.value;
          !!el.triggerEvent && el.triggerEvent('change');
          if (data.value && themeVersion && themeVersion === 'v2') {
            JotForm.corrected(el);
          }
        }
      } catch (e) {
        console.log(e);
      }

      JotForm.triggerWidgetCondition(data.qid);
      JotForm.triggerWidgetCalculation(data.qid);
    }

    // show/hide form errors
    else if (data.type === 'errors') {
      var inputElem = document.getElementById(`input_${data.qid}`);
      // check the action
      if (data.action === 'show') {
        // show error
        if (JotForm.isVisible(inputElem)) {
          JotForm.corrected(inputElem);
          inputElem.value = '';
          inputElem.addClassName('widget-errored');
          JotForm.errored(inputElem, data.msg);

          if ('resetForm' in data && data.resetForm === true) {
            JotForm.enableButtons();
          }
        }
      } else if (data.action === 'hide') {
        // hide error
        inputElem.removeClassName('widget-errored');
        JotForm.corrected(inputElem);
      }
    }

    // make a question/widget required
    else if (data.type === 'required') {
      var inputElem = document.getElementById(`input_${data.qid}`);
      // check the action
      if (data.action === 'set' && !inputElem.hasClassName('widget-required')) {
        inputElem.addClassName('widget-required');
      } else if (data.action === 'unset') {
        inputElem.removeClassName('widget-required');
        JotForm.corrected(inputElem);
      }
    } else if (data.type === 'form:trackerID') {
      sendMessage(JSON.stringify({
        eventID: data.eventID,
        type: 'event:receiver',
        data: $$('[name="event_id"]')[0] ? $$('[name="event_id"]')[0].value : ''
      }), data.qid);
    }

    // requestFrameSize
    else if (data.type === 'size') {
      var { width } = data;
      var { height } = data;

      if (width !== undefined && width !== null) {
        if (Number(width) === 0) {
          width = 'auto';
        }

        if (typeof width === 'number') {
          width = `${width}px`;
        }

        document.getElementById(`customFieldFrame_${data.qid}`).style.width = width;
      }

      if (height !== undefined && height !== null) {
        if (Number(height === 0)) {
          height = 'auto';
        }

        if (typeof height === 'number') {
          height = `${height}px`;
        }

        document.getElementById(`customFieldFrame_${data.qid}`).style.height = height;

        // for IE8 : also update height of li element
        if (getIEVersion() !== undefined) {
          document.getElementById(`cid_${data.qid}`).style.height = height;
        }
      }

      JotForm.iframeHeightCaller();
    }

    // setFrameStyles
    else if (data.type === 'styles') {
      if ('styles' in data && !isEmpty(data.styles)) {
        $(`customFieldFrame_${data.qid}`).setStyle(data.styles);
      }
    }

    // replaceWidget
    else if (data.type === 'replace') {
      try {
        var { inputType } = data;
        var { isMobile } = data;
        var isRequired = data.required;

        var parentDiv = $(`customFieldFrame_${data.qid}`).up();
        var inputName = $(`input_${data.qid}`).readAttribute('name');

        // remove frame
        $(`customFieldFrame_${data.qid}`).remove();
        $(`input_${data.qid}`).up().remove();
        var newInput = '';
        var validationClass = (isRequired) ? 'validate[required] widget-required widget-replaced' : '';
        switch (inputType) {
          case 'control_fileupload':
            var tf = (JotForm.forms[0] == undefined || typeof JotForm.forms[0] === 'undefined') ? $($$('.jotform-form')[0].id) : JotForm.forms[0];
            tf.setAttribute('enctype', 'multipart/form-data');

            if (!isMobile) {
              validationClass = (validationClass === '') ? 'validate[upload]' : validationClass;
              newInput = `<input class="form-upload ${validationClass}" type="file" id="input_${data.qid
              }" name="${inputName}" file-accept="pdf, doc, docx, xls, xlsx, csv, txt, rtf, html, zip, mp3, wma, mpg, flv, avi, jpg, jpeg, png, gif"`
                + 'file-maxsize="10240">';
            }
            // console.log("widget is mobile", widget.isMobile);
            parentDiv.insert(newInput);
            break;
          case 'control_textbox':
            newInput = `<input class="form-textbox ${validationClass}" type="text" data-type-"input-textbox" id="input_${data.qid
            }" name="${inputName}">`;
            parentDiv.insert(newInput);
            break;
          case 'control_textarea':
            newInput = `<textarea class="form-textarea ${validationClass}" type="text" id="input_${data.qid
            }" name="${inputName}" cols="40" rows="6"></textarea>`;
            parentDiv.insert(newInput);
            break;
          default:
            break;
        }
      } catch (e) {
        console.log(e);
      }
    }

    // listen events
    else if (data.type === 'event:listener') {
      // check if target field exist
      var field = document.getElementById(data.field);
      if (field) {
        // only allow certain events for now
        if (['keyup', 'change'].indexOf(data.event) > -1) {
          enableLog && console.log('Event registered from ', data.qid);
          // listen event from a certain field
          var handler = function (el) {
            var fieldValue = el.target.value;
            fieldValue = (typeof fieldValue !== 'undefined') ? fieldValue : '';
            enableLog && console.log('Handler for ', data.qid, 'triggered', fieldValue, el.target.id);
            if (el.target.id === data.field) {
              enableLog && console.log('event:receiver: Sending message to ', data.qid, 'with value', fieldValue);
              sendMessage(JSON.stringify({
                eventID: data.eventID,
                type: 'event:receiver',
                value: fieldValue
              }), data.qid);
            }
          };

          // debounce keyup event if set
          Event.observe(field, data.event, (data.event === 'keyup') ? debounce(handler, 100) : handler);
        }
      }
    }

    // store data to field
    else if (data.type === 'event:store') {
      // check if target field exist
      var field = document.getElementById(data.field);
      if (field) {
        // trigger diff events for other field types
        var targetQID = $(data.field).up('.form-line').id.split('_')[1];
        var messageData = {
          eventID: data.eventID,
          type: 'event:receiver',
          value: data.value
        };

        // send data to widget, if the target is a widget
        // TODO improve this
        if (JotForm.getInputType(targetQID) === 'widget' || ('isWidget' in data && data.isWidget)) {
          if (window.console && 'warn' in console) {
            console.warn('Sending value to destination(widget) from a source(widget) is not recommended.');
          }
          delete messageData.eventID;
          messageData.field = data.field;
          messageData.isWidget = true;
          messageData.targetQID = targetQID;
          enableLog && console.log('Sending data to widget field', targetQID, messageData);
          sendMessage(JSON.stringify(messageData), targetQID);
        } else {
          field.setValue(data.value);
          // if there is a callback, emit an event back to widget
          if ('hasCallback' in data && data.hasCallback) {
            enableLog && console.log('Sending data to native field', data);
            sendMessage(JSON.stringify(messageData), data.qid);
          }
        }
      }
    }

    // hide widget container
    else if (data.type === 'field:hide') {
      $(`input_${data.qid}`).up('.form-line').hide();

      if (window.FORM_MODE && window.FORM_MODE == 'cardform') {
        window.CardForm.setCardVisibility(window.CardForm.cards.filter(card => {
          return card.question.id == data.qid;
        })[0], false);
      }
    }

    // make invisible widget container
    else if (data.type === 'field:invisible') {
      var parentEl, inputEl = document.getElementById(`input_${data.qid}`);
      if (inputEl && (parentEl = inputEl.closest('.form-line'))) {
        parentEl.style.cssText =
          'opacity: 0;' +
          'height: 0;' +
          'margin: 0;' +
          'padding: 0;' +
          'width: 0 !important;';
      }

      if (window.FORM_MODE && window.FORM_MODE == 'cardform') {
        window.CardForm.setCardVisibility(window.CardForm.cards.filter(card => {
          return card.question.id == data.qid;
        })[0], false);
      }
    }

    //reset widget container
    else if (data.type === 'reset') {
      sendReadyMessage(data.qid, data.type);
    }

    // show widget container
    else if (data.type === 'field:show') {
      $(`input_${data.qid}`).up('.form-line').show();
    } else if (data.type === 'fields:capture') {
      var allowedFieldTypes = [
        'control_textbox',
        'control_textarea',
        'control_dropdown',
        'control_datetime',
        'control_phone',
        'control_fullname',
        'control_hidden',
        'control_email'
      ];
      var fieldValues = []; var
        question;

      // fieldSelector can be field ID or field name; field name can be specific like fullname[first] or date[month]
      data.fields.forEach(fieldSelector => {
        var value = '';
        var parent;
        var questionType;

        if (!fieldSelector.match(/\[\w+\]/)) {
          if (data.identifier === 'name') {
            $$('.form-textbox, .form-dropdown, .form-textarea, .form-hidden').some(field => {
              if (field.name.match(new RegExp(`(${fieldSelector}$)|(${fieldSelector}\\[)`))) {
                return parent = field.up('li');
              }
            });
          } else {
            parent = $(`id_${fieldSelector}`);
          }
          questionType = parent ? parent.getAttribute('data-type') : '';
          // question is non-existent or not allowed
          if (!parent || allowedFieldTypes.indexOf(questionType) === -1) {
            fieldValues.push({ selector: fieldSelector, value: '' });
            return;
          }
          // get value for allowed fields
          value = $$(`#${parent.id} input, #${parent.id} select, #${parent.id} textarea`).map(field => {
            if (field.id == `lite_mode_${parent.id}`) { return ''; }
            return field.tagName === 'SELECT' ? field.getSelected().value : field.value;
          }).filter(value => { return !!value; });

          if (questionType === 'control_datetime' && parent.down('[id*=lite_mode_]')) {
            value = parent.down('[id*=lite_mode_]').value;
          }
          value = value.length <= 1 ? (value[0] || '') : value;
        } else {
          var question = $$(`[name$="_${fieldSelector}"]`)[0] || false;
          if (question) {
            value = question.tagName === 'SELECT' ? question.getSelected().value : question.value;
            parent = question.up('li.form-line');
            questionType = question.up('li.form-line').getAttribute('data-type');
          }
        }
        if (typeof value === 'object') {
          var separator = ' ';
          switch (questionType) {
            case 'control_datetime':
              separator = parent.down('.date-separate')
                ? parent.down('.date-separate').innerHTML.replace(/\s|\&nbsp;/g, '') : '/';
              break;
            case 'control_phone':
              separator = '-';
            default:
          }
          value = value.join(separator);
        }
        fieldValues.push({ selector: fieldSelector, value: value, type: questionType || '' });
      });

      sendMessage(JSON.stringify({
        eventID: data.eventID,
        type: 'event:receiver',
        data: fieldValues
      }), data.qid);
    }

    // autofill fields
    else if (data.type === 'fields:fill') {
      // let's fill some fields using their labels/qid
      var dataprops = {};
      $$('.form-line').filter(node => {
        // supported types as of the moment
        return [
          'control_textbox',
          'control_scale',
          'control_radio',
          'control_checkbox',
          'control_dropdown',
          'control_rating',
          'control_datetime',
          'control_fullname',
          'control_phone',
          'control_birthdate',
          'control_address',
          'control_time',
          'control_email',
          'control_textarea',
          'control_emojislider',
          'control_yesno',
          'control_number'
        ].include(node.readAttribute('data-type'));
      }).each((node, index) => {
        // get the id and labelText
        var qid = node.id.split('_')[1];
        var qtype = node.readAttribute('data-type');
        var labelEl;

        if (window.FORM_MODE && window.FORM_MODE == 'cardform') {
          labelEl = node.select('.jfQuestion-label').first();
        } else {
          labelEl = node.select('.form-label').first();
        }

        // handle labels with required(*) text
        var cloneLabelEl = labelEl.clone(true);
        var labelRequiredEl = cloneLabelEl.select('.form-required').first()
            || cloneLabelEl.select('.jfRequiredStar').first();
        if (labelRequiredEl) {
          labelRequiredEl.remove();
        }

        var labelText = (cloneLabelEl) ? cloneLabelEl.innerText || cloneLabelEl.textContent || '' : '';
        var props = {
          name: '',
          value: '',
          items: '',
          text: trim(labelText.toLowerCase()),
          type: qtype
        };

        // find labelText on each fields and assign the right value
        for (var x = 0; x < data.fields.length; x++) {
          var found = false;
          if (data.identifier === 'label') {
            var dataFieldLabel = (data.fields[x].label || '').toString().toLowerCase();
            found = (props.text === dataFieldLabel) ? true : false;
          } else if (data.identifier === 'id') {
            found = (Number(qid) === Number(data.fields[x].id)) ? true : false;
          } else {
            console.error('Unknown identifier', data.identifier, 'use the question label or qid');
            break;
          }

          if (found && $(`cid_${qid}`)) {
            // first look for inputs
            var el = $(`cid_${qid}`).select('input, select, textarea').first();
            if (el) {
              // read type and name attibute
              props.name = el.readAttribute('name').replace(`q${qid}_`, '');
              props.value = data.fields[x].value;

              // for specific types there is `items` props
              var items = data.fields[x].items ? data.fields[x].items : widgetAutoFill().generateCtrlItems(qtype, props.value);
              if (!isEmpty(items)) {
                props.items = items;
              }

              // create qid inside dataprops if not present
              if (!(qid in dataprops)) {
                dataprops[qid] = {};
              }

              // assign qid and value to data variable
              dataprops[qid] = props;
            }
            break;
          }
        }
      });

      // parse dataprops only if not empty
      if (!isEmpty(dataprops)) {
        enableLog && console.log('data props', dataprops);
        widgetAutoFill().parse(dataprops);
      }
      JotForm.runAllCalculations();
    } else if (data.type === 'fields:clear') {
      var fields = [];
      data.fields = data.fields.map(field => {
        return field.toLowerCase();
      });
      $$('.form-label, .jfQuestion-label').each(label => {
        var tempLabel = label.clone(true);
        var requiredElement = tempLabel.select('.form-required, .jfRequiredStar').first();
        if (requiredElement) {
          requiredElement.remove();
        }
        var text = tempLabel.innerText.trim().toLowerCase();

        if (data.fields.indexOf(text) > -1) {
          // get field id and types
          var qid = label.id.match(/_(\d+)$/)[1] || '';
          var type = label.up('.form-line').getAttribute('data-type') || '';
          if (qid && type) {
            fields.push({
              qid: qid,
              type: type
            });
          }
        }
      });
      try {
        widgetAutoFill().clear(fields);
      } catch (e) {
        console.error(e);
      }
    }

    // for submitted frames
    else if (data.type === 'submit:frame:remove') {
      if (JCFServerCommon.submitFrames.length > 0) {
        var findex = JCFServerCommon.submitFrames.indexOf(parseInt(data.qid));
        // remove the submitted reframe
        if (findex >= 0) {
          JCFServerCommon.submitFrames.splice(findex, 1);
        }
      }
    }

    // detects when the frame is moved to another Y position
    else if (data.type === 'frame:move') {
      // get initial Y position of framee
      var documentTop = document.body.getBoundingClientRect().top;
      var frameYPosition = frameObj.getBoundingClientRect().top - documentTop;
      var section = frameObj.up('ul.form-section.page-section');
      if (section) {
        // get initial section height
        var sectionHeight = section.getHeight();
        // observe siblings of iframe for class/style changes
        var widgetPositionObserver = new MutationObserver(mutations => {
          if (JotForm.isVisible(frameObj) && section.getHeight() !== sectionHeight) {
            var newPosition = frameObj.getBoundingClientRect().top - documentTop;
            if (Math.abs(frameYPosition - newPosition) > 5) {
              sectionHeight = section.getHeight();
              frameYPosition = newPosition;
              sendMessage(JSON.stringify({
                eventID: data.eventID,
                type: 'event:receiver',
                data: {
                  position: frameYPosition
                }
              }), data.qid);
            }
          }
        });
        widgetPositionObserver.observe(section, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }
    } else if (data.type === 'frame:getdata') {
      var labelHeight = 0;
      var actionHeight = 0;
      var jfProgressHeight = 0;
      if (window.FORM_MODE == 'cardform' || window.buildermode === 'card') {
        labelHeight = document.getElementById(`label_${id}`).clientHeight;
        actionHeight = document.getElementsByClassName('jfCard-actions')[0].clientHeight;
        jfProgressHeight = document.querySelectorAll('.jfProgress, .no-animate')[0].clientHeight;
      }
      var frameData = {
        width: frameWidth,
        height: frameHeight,
        labelHeight: labelHeight,
        actionHeight: actionHeight,
        jfProgressHeight: jfProgressHeight
      };
      sendMessage(JSON.stringify({
        type: 'event:receiver',
        eventID: data.eventID,
        frameData: frameData
      }), data.qid);
    } else if (data.type === 'disableButtons') {
      JotForm.disableButtons();

    } else if (data.type === 'enableButtons') {
      JotForm.enableButtons();
    }
  }, frameObj.src.replace(/([^:]+:\/\/[^\/]+).*/, '$1'));

  // add widget xd ready class
  frameObj.addClassName('frame-xd-ready').store('frame-xd-ready', true);

  // immediately send the settings to widget
  enableLog && console.log('sending settings', getWidgetSettings(), (new Date()).getTime());
  sendMessage(JSON.stringify({
    type: 'settings',
    settings: getWidgetSettings()
  }), id);

  // immediately send the form strings to widget
  enableLog && console.log('sending form strings', FORM_TEXTS, (new Date()).getTime());
  sendMessage(JSON.stringify({
    type: 'formstrings',
    formTexts: FORM_TEXTS
  }), id);

  // if widget is not visible do not send ready message (it may be on next page)
  // instead send ready message on next page click
  const widgetSection = JotForm.getSection(frameObj);
  const visibleWidgetSection = JotForm.isVisible(widgetSection);
  const visibleFrameObj = JotForm.isVisible(frameObj);
  const isAdvancedDesigner = window.JotForm.isAdvancedDesigner;
  // we need to make widget visible when we use the Section Collapse basic element - ticket #4704578
  const closedSection = frameObj.closest('.form-section-closed');
  var isSectionClosed = closedSection == undefined;
  if(!isSectionClosed && closedSection.querySelector('[data-type="control_collapse"]') != undefined) {
    isSectionClosed = true;
  }
  const isWidgetVisible = frameObj && visibleWidgetSection && (visibleFrameObj || isAdvancedDesigner) && isSectionClosed;
  const allowedWidgets = JotForm.getWidgetType(id) && JotForm.getWidgetType(id).includes('maskedInput');

  const handleJumpToPage = () => {
    const jumpToPage = parseInt(document.get.jumpToPage);
    if (!isNaN(jumpToPage)) {
      const formSections = $$('.form-section:not([id^=section_])');
      const targetSection = formSections[jumpToPage - 1];

      if (widgetSection === targetSection) {
        const jumpInterval = setInterval(() => {
          if (visibleFrameObj) {
            enableLog && console.log(`Form jump to widget page (${jumpToPage}); sending ready message...`);
            sendReadyMessage(id);
            clearInterval(jumpInterval);
          }
        }, 200);
      }
    }
  }

  if(isWidgetVisible || allowedWidgets){
    enableLog && console.log('Frame widget object is visible', visibleWidgetSection, visibleFrameObj, isSectionClosed);
    sendReadyMessage(id);
  } else if (document.get.jumpToPage) {
    // send ready message if the widget's page is to be jumped to
    handleJumpToPage();
  }

  // send message when window was resized
  window.onresize = function () {
    var frameSizes = {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight
    };
    sendMessage(JSON.stringify({
      type: 'frameresize',
      frameSizes: frameSizes
    }), id);
  };

  function widgetSubmit(e) {
    if (document.getElementById(`customFieldFrame_${id}`) === null) {
      return;
    }
    widgetActions.validationEvent = e;

    // do not proceed if submit button is missing
    if ($$('.form-submit-button') && $$('.form-submit-button').length > 0) {
      // if the form submit button is hidden
      // do not submit the form
      var isSubmitBtnVisible = false;
      $$('.form-submit-button').each(el => {
        if (JotForm.isVisible(el.parentNode)) {
          isSubmitBtnVisible = true;
        }
      });

      e.stop();
      e.valid = false;

      if (!isSubmitBtnVisible) {
        JotForm.enableButtons();
      } else {
        nextPage = false;
        enableLog && console.log('Form stopped from widget server event, submitting form from widge submit event');
        sendMessage(JSON.stringify({
          type: 'submit',
          qid: `${id}`
        }), `${id}`);
      }
    }
  }
  // define function name explicitly - name is perserved after minification
  const widgetFnName = _state.widgetName ? `${_state.widgetName})-q${_state.id}` : `q${_state.id}`;
  Object.defineProperty(widgetSubmit, 'name', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: `widget_${widgetFnName}`
  });
  // on form submit
  thisForm.addEventListener('submit', widgetSubmit);

  // on back click
  $$('.form-pagebreak-back').each(b => {
    $(b).observe('click', function() {
      // get widget iframe
      var frameObj = $(this).up('.form-section').select(`#customFieldFrame_${id}`);
      // we need to send the disable message to Iframe Embed widget from the previous page
      if (frameObj.length > 0 && frameObj[0].readAttribute('data-client-id') === '5295629cba137d764f000004') { // check Iframe Embed widget's client ID
        JotForm.disableWidget(id);
      }
      if (JotForm.currentSection.down(`#customFieldFrame_${id}`) && !isWidgetFrameReady(id)) {
        enableLog && console.log('Sending ready message to unready widget');
        sendReadyMessage(id);
      }
    });
  });

  // on pagebreak click
  $$('.form-pagebreak-next').each((b, i) => {
    enableLog && console.log('Going to next page');
    $(b).observe('click', function (e) {
      // get the section where the button is clicked
      // this is to identify what section we were previously in
      // so that we only need to send the submit message to that previous widget from the previous page
      section = this.up('.form-section');
      nextPage = true;
      if (section.select(`#customFieldFrame_${id}`).length > 0) {
        enableLog && console.log('Sending submit message for iframe id', id, 'from section', this.up('.form-section'), 'and iframe', frameObj);
        sendMessage(JSON.stringify({
          type: 'submit',
          method: 'next',
          qid: `${id}`
        }), `${id}`);
        Event.stop(e);
      }

      // send ready message to the next widget of the page only if the section is fully visible
      // we need to get the actual frameobj and section of the next widget on the next page
      // for us to send the ready for that widget
      var checkIntevarl = setInterval(() => {
        // get the actual widget attach to this event
        frameObj = document.getElementById(`customFieldFrame_${id}`);
        if (frameObj) {
          // get its form section
          section = $(frameObj).up('.form-section');

          if (JotForm.isVisible(section) && JotForm.isVisible(frameObj)) {
            // if frame and section is visible
            // throw ready message to every widget that was inside of it
            clearInterval(checkIntevarl);
            enableLog && console.log('Sending ready message for iframe id', id, 'from section', section);
            if (frameObj.getAttribute('data-client-id') === '5295629cba137d764f000004') { // check Iframe Embed widget's client ID
              if(isWidgetFrameReady(id)) {
                JotForm.showWidget(id);
              } else {
                sendReadyMessage(id);
              }
            } else {
              sendReadyMessage(id);
            }
          } else {
            enableLog && console.log('Section and frameObj not visible', section, frameObj);
            clearInterval(checkIntevarl);
          }
        } else {
          // missing iframe - it was replace by a normal question field
          // usually happens on ie8 browsers - for widgets that using JFCustomWidget.replaceWidget method
          clearInterval(checkIntevarl);
        }
      }, 100);
    });
  });

  // observe custom events from widget inputs, then notify client for it
  if ($(`input_${id}`)) {
    ['widget:clear', 'widget:populate', 'widget:shift'].forEach(widgetEvent => {
      $(`input_${id}`).observe(widgetEvent, e => {
        var { qid } = e.memo;
        var message = {
          type: widgetEvent.replace(':', ''),
          qid: qid
        };
        if (widgetEvent == 'widget:populate') {
          message.value = e.memo.value || '';
        }
        sendMessage(JSON.stringify(message), qid);
      });
    });
  }
}
export default widgetFrameLoaded
